import { CheckCircle2 } from 'lucide-react'
import { useTranslation } from '@kostbar/i18n'
import type { PricingImportResponse } from '@/api/endpoints/pricing'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

interface PricingResultProps {
  result: PricingImportResponse
}

export function PricingResult({ result }: PricingResultProps) {
  const { t: tPricing } = useTranslation('pricing')

  if (!result.ok) {
    return null
  }

  return (
    <Alert>
      <CheckCircle2 className="h-4 w-4" />
      <AlertTitle>{tPricing('result.successTitle')}</AlertTitle>
      <AlertDescription>
        {tPricing('result.updated', { count: result.updated })}
      </AlertDescription>
    </Alert>
  )
}
